import { useTranslation } from "react-i18next";

import { Button, Price, PrimaryAction, LinkButton } from "../../Atoms";
import { useVenue } from "../../VenueContext";
import {
  getVenueHasTablePay,
  getVenueHasTablePayOrdering,
} from "../../venueSelectors";
import { useCurrentBillSplit } from "../BillSplit/queries";
import { getCustomerTabBalance, getTotalPaid } from "../BillSplit/selectors";
import { TabDetails } from "../Cart/CartDetailsForm";
import { CartItems } from "../Cart/CartItems";
import { OrderedOrderItems } from "../Cart/OrderedOrderItem";
import { useCustomer } from "../Customer/queries";
import { useCurrentCustomerTab } from "../CustomerTab/queries";
import { CustomerTab } from "../CustomerTab/schema";
import { useSession } from "../Session/SessionContext";
import { getTabTotal } from "../Session/sessionSelectors";
import { useStartTabCheckoutSession } from "./useStartTabCheckoutSession";

export const StartTabCheckoutSession = () => {
  const { t } = useTranslation("onsite");
  const session = useSession();
  const { startTabCheckoutSession, submissionState } =
    useStartTabCheckoutSession();

  return (
    <Button
      type="button"
      onClick={startTabCheckoutSession}
      submissionState={submissionState}
      primary
    >
      {t("cart.payNow")}{" "}
      <Price
        showCurrency
        showDecimals
        value={getTabTotal(session.customerTab)}
      />
    </Button>
  );
};
const LinkToSplitPayments = () => {
  const { t } = useTranslation("onsite");
  const { data: customerTab } = useCurrentCustomerTab();
  const { data: billSplitSession } = useCurrentBillSplit();
  const { data: customer } = useCustomer();

  if (!customerTab) {
    return null;
  }
  const customerTabBalance = getCustomerTabBalance(customerTab);

  if (
    billSplitSession?.customerSessions.find(
      (cs) => cs.customerId === customer?.uuid,
    )
  ) {
    return (
      <LinkButton primary to="/billSplit">
        {t("billSplit.continueSplitting")}{" "}
        <Price value={customerTabBalance} showCurrency />
      </LinkButton>
    );
  }
  if (!billSplitSession) {
    return (
      <LinkButton primary to="/billSplit/start">
        {t("billSplit.settleUp")}{" "}
        <Price value={customerTabBalance} showCurrency />
      </LinkButton>
    );
  } else {
    return (
      <LinkButton primary to="/billSplit/join">
        {t("billSplit.settleUp")}{" "}
        <Price value={customerTabBalance} showCurrency />
      </LinkButton>
    );
  }
};
export const TablePayPayment = ({
  customerTab,
}: {
  customerTab: CustomerTab;
}) => {
  const { t } = useTranslation("onsite");
  const venue = useVenue();
  const hasTablePay = getVenueHasTablePay(venue);
  const hasTablePayOrdering = getVenueHasTablePayOrdering(venue);
  const hasBillSplitting = venue.enabledFeatures.billSplit;

  const totalPaid = getTotalPaid(customerTab);
  const customerTabBalance = getCustomerTabBalance(customerTab);

  return (
    <div>
      <div className="space-y-32">
        <div className="flex-1 space-y-32">
          {hasTablePayOrdering && <CartItems />}
          {hasTablePayOrdering && (
            <div className="">
              <LinkButton secondary to="/">
                {t("cart.addMoreItems")}
              </LinkButton>
            </div>
          )}
          <TabDetails customerTab={customerTab} />
          {hasTablePay && (
            <div className="hidden flex-1 md:block">
              {hasBillSplitting ? (
                <LinkToSplitPayments />
              ) : (
                <StartTabCheckoutSession />
              )}
            </div>
          )}
          {totalPaid != 0 && (
            <>
              <div className="flex justify-between text-lg font-bold">
                <div>{t("onlinePayments.paymentReceived")}</div>
                <div>
                  <Price value={totalPaid} showCurrency />
                </div>
              </div>
              <div className="flex justify-between text-lg font-bold">
                <div>{t("onlinePayments.totalLeftToPay")}</div>
                <div>
                  <Price value={customerTabBalance} showCurrency />
                </div>
              </div>
            </>
          )}
          <OrderedOrderItems />
        </div>
      </div>
      {hasTablePay && (
        <PrimaryAction>
          {hasBillSplitting ? (
            <LinkToSplitPayments />
          ) : (
            <StartTabCheckoutSession />
          )}
        </PrimaryAction>
      )}
    </div>
  );
};
